import React,{ useEffect, useState } from 'react'
import '../App.css'
import {BaseAddress} from '../projConst'
import ListIcons from '../Components/Lib/ListIcons';
import { makeStyles } from '@material-ui/core/styles';
import * as api from "../api/apiFunc";
import * as R from 'ramda'

const useStyles = makeStyles( theme => ({    
  root: {
    display: 'flex',
    textAlign: 'left',
    backgroundColor: '#3f51b5',
    height: '40px',
    width: '100%'
  },
  content: {
    paddingLeft: theme.spacing.unit*3,
   },
   title: {
    // paddingLeft: theme.spacing.unit*3,
    textAlign: 'left',
    color : '#000',
    backgroundColor : '#d9d9d9',
    fontSize: '75%',
  },
}));

const ShowAppHeader = (props) => {
  const classes = useStyles()
  const { config } = props
  const [curBlock, SetCurBlock] = useState([])
  const [iconsApp, SetIconsApp] = useState([])


  useEffect(() => {
    if (api.isEmpty(config.configApp)) return
    SetCurBlock(R.find(R.propEq("block", config.name))(config.configApp)) 
    SetIconsApp(config.iconsApp) 
  }, [config]);

  const headerClick = (id) => alert(`Реализация в проекте ${id} !`)

  const ComputedAccess = () => {
    const { config, iconsapp } = props
    if (!api.isNotEmptyArr(config.iconsApp)) return {}
    let access = {}  
    config.iconsApp.map((icon) => { 
    const iconapp = R.find(R.propEq('ui_app_icon_id', icon.ui_app_icon_id))(config.iconsApp)
    switch (iconapp.ui_app_icon_mnem) { 
      case "apps": access = {...access, [iconapp.ui_app_icon_mnem]: 0 }
    break
    }
    }) 
    return access  
  }
  
  const access = ComputedAccess()


  const ShowViewmode = () => {
    const {viewmode} = props
    return  (<span></span>)
  }
  
  return (
    <header className="apptheme-header App-header">
    
        {curBlock.children && curBlock.children[0] &&
          <ListIcons classnam='div-button-menu' classnamsvg='material-button-menu' icons={curBlock.children[0].icons} iconsapp={iconsApp} access={access} handleOnClick={headerClick} />}
        
        <div className="caption-cell">{props.nameNsi}</div>
    
   
        <div className="user-info">  
              
        {curBlock.children && curBlock.children[2] &&
        <ListIcons classnam="div-button-menu" classnamsvg='user-button' icons={curBlock.children[2].icons} iconsapp={iconsApp} access={{ "avatar": 1 }} nodiv={true} handleOnClick={headerClick} /> }  
        </div>
  </header>
  )
}
export default ShowAppHeader